import { StandardButton } from "../atoms/buttons";
import { TextAtom } from "../atoms/TextAtom";
import { HorizontalLayout } from "../components/layout";

export function PagePagination({ onPageChange, currentPage, totalPages, totalUnits, unitName }) { 
    const handlePrev = () => {
        if (currentPage > 0 && onPageChange) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages - 1 && onPageChange) {
            onPageChange(currentPage + 1);
        }
    };

    const startItem = totalUnits === 0 ? 0 : currentPage * 8 + 1;
    const endItem = Math.min((currentPage + 1) * 8, totalUnits);
    const disabledPrev = currentPage === 0;
    const disabledNext = currentPage === totalPages - 1;
    return (
        <HorizontalLayout className="page-pagination-container space-between">
            <TextAtom className={"pagination-text"} title={<>Weergeven <strong>{startItem}</strong> tot <strong>{endItem}</strong> van <strong>{totalUnits}</strong> {unitName}</>} />
            {totalPages > 1 && (
                    <PaginationButtonGroup
                        onPrev={handlePrev}
                        onNext={handleNext}
                        disabledPrev={disabledPrev}
                        disabledNext={disabledNext}
                    />
            )}
        </HorizontalLayout>
    );
};

const PaginationButtonGroup = ({ onPrev, onNext, disabledPrev, disabledNext }) => {
    return(
          <HorizontalLayout className="pagination-button-group">
                <StandardButton
                    style={{ border: "none", borderRadius: 0 }}
                    className={`${disabledPrev && "disabled"} no-margin-left`}
                    onClick={onPrev}
                    size="medium"
                    arrow={"left"}
                    isDisabled={disabledPrev}
                >
                    <span>Terug</span>
                </StandardButton>
                <StandardButton
                    style={{ border: "none", borderRadius: 0 }}
                    className={`${disabledNext && "disabled"} no-margin-left`}
                    onClick={onNext}
                    size="medium"
                    arrow={"right"}
                    isDisabled={disabledNext}
                >
                    <span>Volgende</span>
                </StandardButton>
            </HorizontalLayout>
    );

}